// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { Tooltip } from '@mui/material';
import { IconButton } from '@shared/ui-kit/components/icon-button';
import { useAdvisorRole } from '@advisor-app/hooks/use-advisor-role';
import { type FC, type MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';

export interface AddOperationsIconButtonProps {
  readonly onClick: MouseEventHandler<HTMLButtonElement>;
  readonly disabled?: boolean;
  readonly 'data-testid'?: string;
}

export const AddOperationsIconButton: FC<AddOperationsIconButtonProps> = ({
  onClick,
  disabled,
  'data-testid': testId = 'send-to-trader-test-button',
}) => {
  const { t } = useTranslation();
  const { canUseTrader } = useAdvisorRole();

  if (!canUseTrader) return null;

  return (
    <Tooltip title={t('common.send-to-trader', { ns: 'common' })}>
      <span>
        <IconButton
          icon="ShoppingCart"
          onClick={onClick}
          data-testid={testId}
          disabled={disabled}
        />
      </span>
    </Tooltip>
  );
};
